import { ProblemsContextProvider } from './ProblemsContext'
import SoapProblemsWidget, {
  type SoapProblemsWidgetProps,
} from './SoapProblemsWidget'

const SoapProblemsWidgetWrapper = ({
  onHideSoapRail,
}: SoapProblemsWidgetProps) => (
  <ProblemsContextProvider>
    <SoapProblemsWidget onHideSoapRail={onHideSoapRail} />
  </ProblemsContextProvider>
)

export default SoapProblemsWidgetWrapper
